module.exports = __webpack_public_path__ + "img/female_user_icon.943cf331.svg";